/* DailyLama — sélecteur d'heures miroir, inversées et répétées.
   Inséré dans le guide existant : aucune route, aucune page de résultat, aucun
   paramètre indexable. Le fragment #heure-11h11 restaure l'état sans créer d'URL.

   Les fonctions pures sont exposées sur DailyLamaHeuresMiroir pour être testées
   réellement, comme pour l'archétype animal. Le montage DOM ne s'exécute que
   dans un navigateur. */
(function (global) {
  'use strict';

  /* ---------------------------------------------------------------- pur */

  var RE_ID = /^([01]\d|2[0-3])h([0-5]\d)$/;

  /** « 11:11 », « 11h11 », « 11 h 11 » → « 11h11 ». Rien d'autre n'est accepté.
     La saisie passe par deux <select> : cette fonction sert surtout au fragment
     d'URL, qui reste une entrée non maîtrisée. */
  function normaliser(brut) {
    if (typeof brut !== 'string') return null;
    if (brut.length > 12) return null;              // borne avant tout traitement
    var t = brut.trim().toLowerCase().replace(/\s+/g, '');
    var m = t.match(/^(\d{1,2})[h:](\d{2})$/);
    if (!m) return null;
    var hh = m[1].length === 1 ? '0' + m[1] : m[1];
    var id = hh + 'h' + m[2];
    return RE_ID.test(id) ? id : null;
  }

  /** Identifiant présent dans le catalogue. Une heure valide au format mais
     absente du catalogue n'est PAS une heure de l'outil. */
  function valider(id, catalogue) {
    if (!id || !catalogue) return null;
    for (var i = 0; i < catalogue.length; i++) {
      if (catalogue[i].id === id) return catalogue[i];
    }
    return null;
  }

  function parFamille(catalogue, type) {
    var out = [];
    for (var i = 0; i < catalogue.length; i++) {
      if (catalogue[i].type === type) out.push(catalogue[i]);
    }
    return out;
  }

  /** Heures liées : lues dans les données, jamais recalculées ici. On ne garde
     que celles qui existent réellement dans le catalogue. */
  function liees(entree, catalogue) {
    if (!entree || !entree.related) return [];
    var out = [];
    for (var i = 0; i < entree.related.length; i++) {
      var e = valider(entree.related[i], catalogue);
      if (e && e.id !== entree.id) out.push(e);
    }
    return out;
  }

  function versFragment(id) {
    return id ? '#heure-' + id : '';
  }

  /** Un fragment inconnu est ignoré, jamais affiché, jamais réinjecté. */
  function depuisFragment(frag, catalogue) {
    if (typeof frag !== 'string') return null;
    var m = frag.replace(/^#/, '').match(/^heure-(.+)$/);
    if (!m) return null;
    return valider(normaliser(m[1]), catalogue);
  }

  /** Texte de partage : neutre, sans donnée personnelle, sans HTML. */
  function textePartage(entree, familles, hub) {
    if (!entree) return null;
    var nom = (familles && familles[entree.type] && familles[entree.type].nom) || 'Heure';
    return nom + ' ' + entree.label + ' — la lecture symbolique sur DailyLama\n'
         + hub + versFragment(entree.id);
  }

  /** Un lien n'est accepté que s'il reste chez DailyLama : chemin relatif, ou
     URL absolue sur dailylama.shop. Le réglage de section est saisi dans
     l'éditeur de thème, pas par un visiteur — mais une URL non bornée dans un
     champ libre finit toujours par pointer ailleurs. */
  function lienInterne(url) {
    if (typeof url !== 'string' || !url) return null;
    var t = url.trim();
    if (/^\/[^\/]/.test(t)) return t;                       // /pages/... , jamais //
    var m = t.match(/^https:\/\/([^\/?#]+)(\/.*)?$/i);
    if (m && m[1].toLowerCase() === 'dailylama.shop') return t;
    return null;
  }

  var API = {
    lienInterne: lienInterne,
    normaliser: normaliser,
    valider: valider,
    parFamille: parFamille,
    liees: liees,
    versFragment: versFragment,
    depuisFragment: depuisFragment,
    textePartage: textePartage,
  };

  if (typeof module !== 'undefined' && module.exports) module.exports = API;
  global.DailyLamaHeuresMiroir = API;

  if (typeof document === 'undefined') return;      // require() en test : on s'arrête ici

  /* -------------------------------------------------------------- suivi */

  /* Transport canonique du projet : data-api -> /events, charge { name, props }.
     C'est la forme que le serveur lit réellement (backend/api/v1/events.ts lit
     body.props) ; une charge plate perdrait ses propriétés en silence. */
  var EVENEMENTS = ['mirror_time_tool_view', 'mirror_time_tool_start',
                    'mirror_time_result_view', 'mirror_time_article_click',
                    'mirror_time_share', 'mirror_time_related_tool_click'];
  var PROPS_AUTORISEES = ['type', 'source_component', 'has_article', 'share_method'];

  function pister(racine, nom, props) {
    if (EVENEMENTS.indexOf(nom) === -1) return;
    var base = racine.getAttribute('data-api');
    if (!base) return;                              // abstraction inactive, sans erreur
    if (racine.getAttribute('data-suivi') !== 'actif') return;
    try {
      var p = {};
      for (var i = 0; i < PROPS_AUTORISEES.length; i++) {
        var k = PROPS_AUTORISEES[i];
        if (props && props[k] !== undefined && props[k] !== null) p[k] = String(props[k]);
      }
      global.fetch(base.replace(/\/$/, '') + '/events', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: nom, props: p }), keepalive: true,
      }).catch(function () {});
    } catch (e) { /* le suivi ne casse jamais l'outil */ }
  }

  /* -------------------------------------------------------------- montage */

  /**
   * Remonte la section dans le corps de l'article, après le Nième paragraphe.
   *
   * Une section ajoutée au modèle d'article se place après la section qui rend
   * l'article entier : le module se retrouve tout en bas, et sur toute la
   * largeur de la page. On le déplace côté navigateur plutôt que de toucher à
   * `main-article.liquid`, qui rend TOUS les articles de la boutique.
   *
   * Même convention d'attributs que `dream-cta-article`, et même dégradation :
   * si le conteneur d'article est introuvable, le module reste où il est. Il
   * est alors mal placé, mais présent et fonctionnel — jamais absent.
   */
  /**
   * Le fil du texte, qui n'est pas toujours le conteneur d'article.
   *
   * Certains articles enveloppent tout leur corps dans un <article> ou un <div>
   * imbriqué ; les paragraphes de premier niveau du conteneur sont alors les
   * quelques-uns qui traînent APRÈS, tout en bas. Ancrer dessus posait le module
   * au pied de la page — exactement ce qu'on cherchait à corriger.
   *
   * On retient donc l'élément qui porte le plus de paragraphes en enfants
   * directs : c'est celui qui contient le fil de lecture, quelle que soit la
   * profondeur à laquelle le thème ou l'éditeur l'a rangé.
   */
  function fluxDe(conteneur) {
    var meilleur = conteneur;
    var max = conteneur.querySelectorAll(':scope > p').length;
    var candidats = conteneur.querySelectorAll('article, section, div');
    for (var i = 0; i < candidats.length; i++) {
      var n = candidats[i].querySelectorAll(':scope > p').length;
      if (n > max) { max = n; meilleur = candidats[i]; }
    }
    return max ? meilleur : null;
  }

  /**
   * Remonte la section dans le corps de l'article, après le Nième paragraphe.
   *
   * Une section ajoutée au modèle d'article se place après la section qui rend
   * l'article entier : le module se retrouve tout en bas, et sur toute la
   * largeur de la page. On le déplace côté navigateur plutôt que de toucher à
   * `main-article.liquid`, qui rend TOUS les articles de la boutique.
   *
   * Même convention d'attributs que `dream-cta-article`, et même dégradation :
   * si le corps de l'article est introuvable, le module reste où il est. Il est
   * alors mal placé, mais présent et fonctionnel — jamais absent.
   */
  function remonter(racine) {
    var selecteurs = racine.getAttribute('data-dl-move-into');
    if (!selecteurs) return;
    var conteneur = null;
    var liste = selecteurs.split(',');
    for (var i = 0; i < liste.length && !conteneur; i++) {
      conteneur = document.querySelector(liste[i].trim());
    }
    // `contains` : au rechargement d'une section dans l'éditeur de thème, le
    // module peut déjà être dans l'article. Le redéplacer le ferait descendre.
    if (!conteneur || conteneur.contains(racine)) return;

    var flux = fluxDe(conteneur);
    if (!flux) return;
    var paras = flux.querySelectorAll(':scope > p');
    if (!paras.length) return;

    var apres = parseInt(racine.getAttribute('data-dl-move-after') || '1', 10);
    if (!(apres > 0)) apres = 1;
    var ancre = paras[Math.min(apres, paras.length) - 1];
    if (!ancre || ancre.parentNode !== flux) return;
    flux.insertBefore(racine, ancre.nextSibling);
  }

  /**
   * Amène un élément à l'écran, animé quand c'est possible.
   *
   * `behavior: 'smooth'` ne défile pas du tout dans certains contextes — mesuré
   * ici même : `'auto'` amenait la page à 626 px, `'smooth'` la laissait à 0.
   * Le confort ne vaut pas un bouton qui ne fait rien : on tente l'animation,
   * et si la page n'a pas bougé au bout d'un instant, on saute directement.
   *
   * Le saut direct est aussi ce que reçoit qui a demandé qu'on limite les
   * animations, sans passer par l'attente.
   */
  function amener(cible) {
    var doux = !(global.matchMedia
      && global.matchMedia('(prefers-reduced-motion: reduce)').matches);
    if (!doux) { cible.scrollIntoView({ block: 'center' }); return; }
    var depart = global.scrollY || 0;
    cible.scrollIntoView({ block: 'center', behavior: 'smooth' });
    global.setTimeout(function () {
      if (Math.abs((global.scrollY || 0) - depart) < 4) {
        cible.scrollIntoView({ block: 'center' });
      }
    }, 350);
  }

  function monter(racine) {
    if (racine.getAttribute('data-dl-monte') === '1') return;   // éditeur de thème
    racine.setAttribute('data-dl-monte', '1');

    remonter(racine);

    var $ = function (s) { return racine.querySelector(s); };
    var $$ = function (s) { return [].slice.call(racine.querySelectorAll(s)); };

    var brut = $('[data-dlhm-donnees]');
    var data;
    try { data = JSON.parse(brut.textContent); } catch (e) { data = null; }
    if (!data || !data.heures || !data.heures.length) return;   // le contenu reste lisible

    var catalogue = data.heures, familles = data.familles, hub = data.hub;
    var outilUrl = lienInterne(racine.getAttribute('data-outil-url'));
    var outilTexte = racine.getAttribute('data-outil-texte') || '';
    var selH = $('[data-dlhm-h]'), selM = $('[data-dlhm-m]');
    var grille = $('[data-dlhm-grille]'), compte = $('[data-dlhm-compte]');
    var zone = $('[data-dlhm-resultat]'), erreur = $('[data-dlhm-erreur]');
    var demarre = false;

    function demarrer() {
      if (demarre) return;
      demarre = true;
      pister(racine, 'mirror_time_tool_start', { source_component: 'guide_heures_miroir' });
    }

    /* --- grille --- */
    var familleActive = 'miroir';

    function dessinerGrille() {
      var liste = parFamille(catalogue, familleActive);
      grille.textContent = '';
      liste.forEach(function (e) {
        var b = document.createElement('button');
        b.type = 'button';
        /* Aucune heure n'est désactivée : les lacunes portent une bordure en
           pointillés, jamais un état grisé. L'information ne tient pas à la couleur
           seule — un texte pour lecteur d'écran la double. */
        b.className = 'dlhm-heure' + (e.articleUrl ? '' : ' dlhm-heure--general');
        b.setAttribute('data-heure', e.id);
        b.setAttribute('aria-pressed', 'false');
        var s = document.createElement('span');
        s.className = 'dlhm-heure__label';
        s.textContent = e.label;                     // jamais innerHTML
        b.appendChild(s);
        if (e.articleUrl) {
          /* Deux signaux, comme la maquette : la pastille dit « article dédié »,
             le pointillé dit « lecture de famille ». Ni l'un ni l'autre n'est
             porté par la couleur seule — le texte ci-dessous les double. */
          var pt = document.createElement('span');
          pt.className = 'dlhm-heure__point';
          pt.setAttribute('aria-hidden', 'true');
          b.appendChild(pt);
        }
        var sr = document.createElement('span');
        sr.className = 'dlhm-sr';
        sr.textContent = e.articleUrl ? ' — lecture détaillée disponible'
                                      : ' — lecture de famille';
        b.appendChild(sr);
        b.addEventListener('click', function () { demarrer(); choisir(e.id, 'grille'); });
        grille.appendChild(b);
      });
      var avec = liste.filter(function (e) { return e.articleUrl; }).length;
      compte.textContent = liste.length + ' heures dans cette famille. '
        + avec + (avec > 1 ? ' disposent' : ' dispose') + ' d’une lecture détaillée'
        + (avec < liste.length ? ' ; les autres ouvrent la lecture de famille.' : '.');
    }

    /* L'état pressé appartient aux onglets, et se lit sur la FAMILLE, pas sur le
       bouton cliqué. En le posant sur le bouton cliqué, un clic depuis une carte
       « Ouvrir cet onglet » éteignait l'onglet correspondant : la grille changeait,
       la barre d'onglets disait le contraire. */
    function activerFamille(type) {
      if (!type || type === familleActive) return false;
      familleActive = type;
      $$('.dlhm-filtre[data-dlhm-famille]').forEach(function (x) {
        var actif = x.getAttribute('data-dlhm-famille') === type;
        x.classList.toggle('est-actif', actif);
        x.setAttribute('aria-pressed', actif ? 'true' : 'false');
      });
      demarrer();
      dessinerGrille();
      return true;
    }

    $$('.dlhm-filtre[data-dlhm-famille]').forEach(function (b) {
      b.addEventListener('click', function () {
        activerFamille(b.getAttribute('data-dlhm-famille'));
      });
    });

    /* Les cartes « Trois familles d'heures » sont sous la grille, souvent hors de
       l'écran. Changer l'onglet sans y emmener le lecteur ne produisait aucun effet
       visible : le bouton passait pour cassé. Il ouvre donc la grille repliée des
       petits écrans, puis la ramène à l'écran. */
    $$('.dlhm-famille__btn[data-dlhm-famille]').forEach(function (b) {
      b.addEventListener('click', function () {
        activerFamille(b.getAttribute('data-dlhm-famille'));
        var hote = $('[data-dlhm-grille-hote]');
        var bascule = $('[data-dlhm-bascule]');
        if (hote && bascule && global.getComputedStyle(bascule).display !== 'none'
            && !hote.classList.contains('est-ouvert')) {
          hote.classList.add('est-ouvert');
          bascule.setAttribute('aria-expanded', 'true');
          bascule.textContent = 'Masquer les heures';
        }
        var cible = $('.dlhm-filtres') || hote;
        if (cible && cible.scrollIntoView) amener(cible);
      });
    });

    /* --- sélection --- */
    function choisir(id, origine) {
      var e = valider(id, catalogue);
      if (!e) { montrerErreur(id ? id.replace('h', ':') : null); return; }
      erreur.textContent = '';
      selH.value = e.id.slice(0, 2);
      selM.value = e.id.slice(3);
      $$('[data-heure]').forEach(function (b) {
        var actif = b.getAttribute('data-heure') === e.id;
        b.classList.toggle('est-choisie', actif);
        b.setAttribute('aria-pressed', actif ? 'true' : 'false');
      });
      rendre(e);
      if (global.history && global.history.replaceState) {
        global.history.replaceState(null, '', versFragment(e.id));
      }
      pister(racine, 'mirror_time_result_view', {
        type: e.type, has_article: e.articleUrl ? 'oui' : 'non',
        source_component: origine === 'grille' ? 'grille' : 'saisie',
      });
    }

    /* Trois suggestions tirées du catalogue, une par famille, toujours avec article :
       un message d'erreur qui ne propose rien laisse la personne bloquée. */
    function suggestions() {
      var out = [];
      ['miroir', 'inversee', 'repetition'].forEach(function (t) {
        var c = parFamille(catalogue, t).filter(function (x) { return x.articleUrl; });
        if (c.length) out.push(c[Math.floor(c.length / 2)].label);
      });
      return out;
    }

    function montrerErreur(saisie) {
      var s = suggestions();
      erreur.textContent = (saisie ? saisie + ' n’appartient' : 'Cette heure n’appartient')
        + ' à aucune des trois familles.'
        + (s.length ? ' Essayez ' + s.slice(0, 2).join(', ') + ' ou ' + s[2] + '.' : '');
      zone.textContent = '';
    }

    /* --- résultat --- */
    /* Structure reprise de la maquette : bandeau, heure en grand, puce de famille,
       lecture, « à observer », actions, heures liées, autre outil, emplacement
       réservé. Le TITRE éditorial n'est rendu que si la donnée existe : aucun lot
       n'étant validé, il reste absent plutôt que fabriqué. */
    function rendre(e) {
      zone.textContent = '';
      var fam = familles[e.type] || { nom: 'Heure', resume: '' };

      var carte = document.createElement('div');
      carte.className = 'dlhm-carte';

      var oeil = document.createElement('p');
      oeil.className = 'dlhm-carte__oeil';
      oeil.textContent = 'Heure sélectionnée';
      carte.appendChild(oeil);

      /* Deux colonnes comme la maquette : la lecture à gauche, les heures liées
         dans leur propre encadré à droite. Une seule colonne rejetait le lien
         vers l'article très bas et cassait le rythme de la page. */
      var duo = document.createElement('div');
      duo.className = 'dlhm-duo';
      var gauche = document.createElement('div');
      gauche.className = 'dlhm-duo__lecture';
      var droite = document.createElement('aside');
      droite.className = 'dlhm-duo__cote';
      duo.appendChild(gauche); duo.appendChild(droite);
      carte.appendChild(duo);

      /* L'heure et le titre partagent une ligne : l'heure est l'ancre visuelle,
         le titre la prolonge. */
      var tete = document.createElement('div');
      tete.className = 'dlhm-tete';
      gauche.appendChild(tete);

      var h = document.createElement('h3');
      h.className = 'dlhm-carte__heure';
      h.setAttribute('tabindex', '-1');
      h.textContent = e.label;
      tete.appendChild(h);

      var puce = document.createElement('span');
      puce.className = 'dlhm-puce-famille';
      puce.textContent = fam.nom;
      tete.appendChild(puce);

      var titres = document.createElement('div');
      titres.className = 'dlhm-duo__corps';
      gauche.appendChild(titres);

      if (e.summary && e.title) {
        var t = document.createElement('p');
        t.className = 'dlhm-carte__titre';
        t.textContent = e.title;
        titres.appendChild(t);
      }

      var p = document.createElement('p');
      p.className = 'dlhm-carte__texte';
      p.textContent = e.summary || fam.resume;
      titres.appendChild(p);

      var obsT = document.createElement('p');
      obsT.className = 'dlhm-carte__oeil dlhm-carte__oeil--second';
      obsT.textContent = 'À observer aujourd’hui';
      titres.appendChild(obsT);
      var obs = document.createElement('p');
      obs.className = 'dlhm-carte__piste';
      obs.textContent = e.reflectionPrompt || data.pisteCommune;
      titres.appendChild(obs);

      var actions = document.createElement('div');
      actions.className = 'dlhm-actions';
      if (e.articleUrl) {
        var a = document.createElement('a');
        a.className = 'dlhm-btn dlhm-btn--principal';
        a.href = e.articleUrl;
        a.textContent = 'Lire la signification complète';
        a.addEventListener('click', function () {
          pister(racine, 'mirror_time_article_click', { type: e.type, has_article: 'oui' });
        });
        actions.appendChild(a);
      } else {
        /* Lacune : on le DIT, sans URL inventée ni « article bientôt disponible » —
           aucun calendrier de publication ne l'assure. */
        var note = document.createElement('p');
        note.className = 'dlhm-carte__lacune';
        note.textContent = 'Cette heure appartient aux ' + fam.pluriel
          + '. DailyLama ne possède pas encore de lecture détaillée dédiée ; vous pouvez '
          + 'explorer le guide général et les heures proches déjà documentées.';
        titres.appendChild(note);

        var g = document.createElement('a');
        g.className = 'dlhm-btn dlhm-btn--principal';
        g.href = hub;
        g.textContent = 'Comprendre les ' + fam.pluriel;
        actions.appendChild(g);

        var proche = liees(e, catalogue)[0];
        if (proche) {
          var pb = document.createElement('button');
          pb.type = 'button';
          pb.className = 'dlhm-btn dlhm-btn--secondaire';
          pb.textContent = 'Explorer une heure proche';
          pb.addEventListener('click', function () { choisir(proche.id, 'liee'); });
          actions.appendChild(pb);
        }
      }
      var autre = document.createElement('button');
      autre.type = 'button';
      autre.className = 'dlhm-btn dlhm-btn--secondaire';
      autre.textContent = 'Choisir une autre heure';
      autre.addEventListener('click', function () {
        zone.textContent = '';
        $$('[data-heure]').forEach(function (b) {
          b.classList.remove('est-choisie'); b.setAttribute('aria-pressed', 'false');
        });
        var pr = racine.querySelector('[data-dlhm-grille]');
        if (pr) pr.scrollIntoView({ block: 'center' });
      });
      actions.appendChild(autre);

      var part = document.createElement('button');
      part.type = 'button';
      part.className = 'dlhm-btn dlhm-btn--secondaire';
      part.textContent = 'Partager';
      part.addEventListener('click', function () { partager(e, part, 'partage'); });
      actions.appendChild(part);

      var copie = document.createElement('button');
      copie.type = 'button';
      copie.className = 'dlhm-btn dlhm-btn--secondaire';
      copie.textContent = 'Copier le lien';
      copie.addEventListener('click', function () { partager(e, copie, 'copie'); });
      actions.appendChild(copie);
      titres.appendChild(actions);
      var msg = document.createElement('p');
      msg.className = 'dlhm-partage-msg';
      msg.setAttribute('data-dlhm-partage-msg', '');
      msg.setAttribute('role', 'status');
      titres.appendChild(msg);

      var proches = liees(e, catalogue);
      if (proches.length) {
        var st = document.createElement('p');
        st.className = 'dlhm-carte__oeil dlhm-carte__oeil--second';
        st.textContent = 'Heures liées';
        droite.appendChild(st);
        var ul = document.createElement('ul');
        ul.className = 'dlhm-liees';
        proches.forEach(function (v) {
          var li = document.createElement('li');
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'dlhm-liee';
          var hh = document.createElement('span');
          hh.className = 'dlhm-liee__heure';
          hh.textContent = v.label;
          var ss = document.createElement('span');
          ss.className = 'dlhm-liee__sous';
          /* Sous-titre factuel, dérivé du catalogue : famille + disponibilité.
             Pas de titre éditorial, il n'en existe aucun. */
          ss.textContent = (familles[v.type] || {}).nom + ' · lecture disponible';
          var fl = document.createElement('span');
          fl.className = 'dlhm-liee__fleche';
          fl.setAttribute('aria-hidden', 'true');
          fl.textContent = '→';
          b.appendChild(hh); b.appendChild(ss); b.appendChild(fl);
          b.addEventListener('click', function () { choisir(v.id, 'liee'); });
          li.appendChild(b);
          ul.appendChild(li);
        });
        droite.appendChild(ul);
      }

      if (outilUrl && outilTexte) {
        var so = document.createElement('p');
        so.className = 'dlhm-carte__oeil dlhm-carte__oeil--second';
        so.textContent = 'Autre outil DailyLama';
        droite.appendChild(so);
        var lo = document.createElement('a');
        lo.className = 'dlhm-outil';
        lo.href = outilUrl;   // déjà borné par lienInterne
        lo.textContent = outilTexte;
        lo.addEventListener('click', function () {
          pister(racine, 'mirror_time_related_tool_click', { type: e.type });
        });
        droite.appendChild(lo);
      }

      var avert = document.createElement('p');
      avert.className = 'dlhm-carte__avert';
      avert.textContent = 'Lecture symbolique proposée à titre d’introspection. '
        + 'Elle ne prédit rien et ne remplace aucun avis professionnel.';
      carte.appendChild(avert);

      zone.appendChild(carte);
      h.focus();
    }

    /* --- partage --- */
    function partager(e, bouton, mode) {
      var texte = textePartage(e, familles, hub);
      var fini = function (methode) {
        var m = racine.querySelector('[data-dlhm-partage-msg]');
        if (m) {
          m.textContent = 'Lien copié — il pointe vers cette page.';
          global.setTimeout(function () { m.textContent = ''; }, 4000);
        }
        pister(racine, 'mirror_time_share', { type: e.type, share_method: methode });
      };
      if (mode !== 'copie' && global.navigator && global.navigator.share) {
        global.navigator.share({ text: texte }).then(function () { fini('web_share'); })
          .catch(function () {});
        return;
      }
      if (global.navigator && global.navigator.clipboard) {
        global.navigator.clipboard.writeText(texte).then(function () { fini('presse_papier'); })
          .catch(function () { copieManuelle(texte, fini); });
        return;
      }
      copieManuelle(texte, fini);
    }

    function copieManuelle(texte, fini) {
      var z = document.createElement('textarea');
      z.value = texte;
      z.setAttribute('readonly', 'readonly');
      z.className = 'dlhm-sr';
      racine.appendChild(z);
      z.select();
      try { document.execCommand('copy'); fini('copie_manuelle'); } catch (err) { /* rien */ }
      racine.removeChild(z);
    }

    /* --- saisie --- */
    var valider_btn = $('[data-dlhm-valider]');
    if (valider_btn) {
      valider_btn.addEventListener('click', function () {
        demarrer();
        choisir(selH.value + 'h' + selM.value, 'saisie');
      });
    }
    [selH, selM].forEach(function (s) {
      if (s) s.addEventListener('change', function () { demarrer(); erreur.textContent = ''; });
    });
    var exemple = $('[data-dlhm-exemple]');
    if (exemple) {
      exemple.addEventListener('click', function () { demarrer(); choisir('11h11', 'exemple'); });
    }

    /* Sur petit écran la grille est repliée : 24 cartes poussent le résultat très
       bas. Le bouton n'existe que si le gabarit le fournit, et il annonce son état. */
    var bascule = $('[data-dlhm-bascule]');
    var hote = $('[data-dlhm-grille-hote]');
    if (bascule && hote) {
      bascule.addEventListener('click', function () {
        var ouvert = hote.classList.toggle('est-ouvert');
        bascule.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
        bascule.textContent = ouvert ? 'Masquer les heures' : 'Parcourir les heures';
        if (ouvert) { demarrer(); hote.scrollIntoView({ block: 'nearest' }); }
      });
    }

    /* --- démarrage --- */
    dessinerGrille();
    var depuis = depuisFragment(global.location.hash, catalogue);
    if (depuis) {
      familleActive = depuis.type;
      $$('.dlhm-filtre[data-dlhm-famille]').forEach(function (x) {
        var actif = x.getAttribute('data-dlhm-famille') === depuis.type;
        x.classList.toggle('est-actif', actif);
        x.setAttribute('aria-pressed', actif ? 'true' : 'false');
      });
      dessinerGrille();
      choisir(depuis.id, 'fragment');
    }

    /* Vue : émise une seule fois, et seulement si l'outil entre réellement à l'écran. */
    if (global.IntersectionObserver) {
      var io = new global.IntersectionObserver(function (entrees) {
        entrees.forEach(function (x) {
          if (!x.isIntersecting) return;
          io.disconnect();
          pister(racine, 'mirror_time_tool_view', { source_component: 'guide_heures_miroir' });
        });
      }, { threshold: 0.5 });
      io.observe(racine);
    }
  }

  function demarrage() {
    [].slice.call(document.querySelectorAll('[data-dlhm]')).forEach(monter);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrage);
  } else { demarrage(); }
  document.addEventListener('shopify:section:load', demarrage);

})(typeof window !== 'undefined' ? window : globalThis);
